
import React, { useState, useEffect } from "react";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import InputComponent from "../../Components/Shared/FormInputs/FormInputs";
import { FULL_API_BASE_URL } from "../../Config/Config";
import TextEditor from "../Landing/components/TextEditor";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../Assets/Images/CommanImages/success.png";
import MultiSelectSearchDropdown from "../CreateQuestionsPaper/SearchDropDown/MultiSelectSearchDropdown";
import { POST, GET } from "../../Api/HttpsMethods";
import EndPoints from "../../Api/EndPoints";
import { useNavigate } from "react-router-dom";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import QuickFileUpload from "./QuickFileUpload";
import QuickDPPSchedulingTable from "./QuickDPPSchedulingTable";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";

// TODO: remove this default once QuickFileUpload calls onUploadSuccess with a real id.
const DEFAULT_PARSE_QUES_SET_ID = "2533";

// ── table headers (passed to QuickDPPSchedulingTable) ───────────────────────
const TABLE_HEADERS = [
  "Q No",
  "Question Text",
  "Question Type",
  "Chapter",
  "Topic",
  "Difficulty Level",
  "Status",
  "Course",
  "Subject",
];

const getTag = (q, name) =>
  q?.tags?.find((t) => t.tag_name === name)?.tag_value || "";

const stripHtml = (s) =>
  String(s ?? "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, " ");

const renderContent = (raw) => {
  const decoded = he.decode(stripHtml(raw));
  return decoded.split(/(imgsrc=[^ ]+)/g).map((seg, i) =>
    seg.startsWith("imgsrc=") ? (
      <img
        key={i}
        src={seg.replace("imgsrc=", "")}
        alt={`Question Image ${i}`}
        style={{ maxWidth: "300px", height: "auto", margin: "5px", verticalAlign: "middle" }}
      />
    ) : (
      <span key={i}>
        <Latex>{seg}</Latex>
      </span>
    )
  );
};

// adjust keys here if your API uses different names
const getOptions = (q) => {
  const list = q?.options || q?.ques_options || q?.question_options || [];
  return Array.isArray(list)
    ? list.map((o) => ({
        text: o?.option_text ?? o?.option ?? o?.text ?? (typeof o === "string" ? o : ""),
        correct: !!(o?.is_correct ?? o?.is_right ?? o?.correct),
      }))
    : [];
};

const buildRow = (q, index) => ({
  id: q.question_id ?? q.id ?? `row-${index}`,
  status: q.status,
  raw: q,
  cells: {
    "Q No": q.ques_no ?? index + 1,
    "Question Text": q.question_text || "",
    "Question Type": q.ques_type_text || q.ques_type || "",
    Chapter: getTag(q, "Chapter"),
    Topic: getTag(q, "Topic"),
    "Difficulty Level": getTag(q, "Difficulty Level"),
    Status: q.status_txt || "",
    Course: q.course_name || "",
    Subject: q.subject_name || "",
  },
});

const QuickDPPSchedulingDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const navigate = useNavigate();
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const accessToken = localStorage.getItem("other");

  const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] = useState("");
  const [selectedChapterId, setSelectedChapterId] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
  const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [classes, setClasses] = useState([]);
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);
  const [batches, setBatches] = useState([]);
  const [dppName, setDppName] = useState("");
  const [DppDescription, setDppDescription] = useState("");
  const [CordinatorName, setCordinatorName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState([]);
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedSubjectName, setSelectedSubjectName] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [studentGroupsError, setStudentGroupsError] = useState(null);
  const [serverCurrentTime, setServerCurrentTime] = useState(null);
  const [fillInTheBlanksSuggestions, setFillInTheBlanksSuggestions] = useState("");
  const [isOpenUpload, setIsOpenUpload] = useState(true);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [parseQuesSetId, setParseQuesSetId] = useState(DEFAULT_PARSE_QUES_SET_ID);
  const [isOpenInstructions, setIsOpenInstructions] = useState(false);
  const toggleInstructions = () => setIsOpenInstructions((prev) => !prev);

  // ── parsed questions table state (data + headers go to the table) ─────────
  const [tableHeaders, setTableHeaders] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableError, setTableError] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [showOptions, setShowOptions] = useState(true);

  const handlePreview = () => {
    if (!tableRows.length) return showMessage("No questions to preview.", ErrorImg);
    setShowOptions(true);
    setIsPreviewOpen(true);
  };
  const showMessage = (text, img) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{text}</span>
        </div>
      </div>
    );
    setActiveImg(img);
    setIsMessageBoxVisible(true);
  };

  const apiMsgProps = { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg };

  const formatDateTime = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const mins = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
    base.setMinutes(base.getMinutes() + 15);
    return formatDateTime(base);
  };

  // start + 24 hours
  const getMinEndDateTime = (startDateTime) => {
    if (!startDateTime) return getCurrentDateTime();
    return formatDateTime(
      new Date(new Date(startDateTime).getTime() + 24 * 60 * 60 * 1000)
    );
  };

  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-current-datetime/`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString());
      }
    };
    fetchServerTime();
  }, []);

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        setTestTemplates(await response.json());
      } catch (error) {
        console.error("Error fetching test templates:", error);
        showMessage(`Error fetching test templates: ${error.message}`, ErrorImg);
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  // ── API: parsed questions (table data) ────────────────────────────────────
  useEffect(() => {
    if (!parseQuesSetId || !clientId || !clientBranchId) {
      setTableHeaders([]);
      setTableRows([]);
      return;
    }
    const fetchParsedQuestions = async () => {
      setTableLoading(true);
      setTableError("");
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-parsed-questions/?client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_id=${parseQuesSetId}`,
          {
            method: "GET",
            headers: {
              accept: "*/*",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        const list = Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
          ? result.data
          : [];
        setTableHeaders(TABLE_HEADERS);
        setTableRows(list.map((q, i) => buildRow(q, i)));
      } catch (err) {
        console.error("Error fetching parsed questions:", err);
        setTableError(err.message || "Failed to load questions");
        setTableHeaders(TABLE_HEADERS);
        setTableRows([]);
      } finally {
        setTableLoading(false);
      }
    };
    fetchParsedQuestions();
  }, [parseQuesSetId, clientId, clientBranchId, refreshKey]);

  // ── API: courses ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`, {
          headers: { accept: "application/json" },
        });
        const data = await response.json();
        setCourses(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  // ── API: classes ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchClasses = async () => {
      const data = await GET.noToken(EndPoints.GetClasses, apiMsgProps);
      if (Array.isArray(data)) setClasses(data);
    };
    fetchClasses();
  }, []);

  // ── API: batches ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchBatches = async () => {
      if (!selectedCourseId) {
        setBatches([]);
        return;
      }
      const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, apiMsgProps);
      if (Array.isArray(data?.[0])) {
        setBatches(
          selectedClassId
            ? data[0].filter(
              (batch) => String(batch.class_id) === String(selectedClassId)
            )
            : data[0]
        );
      } else setBatches([]);
    };
    fetchBatches();
  }, [selectedCourseId, selectedClassId]);

  // ── API: subjects ─────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedCourseId) {
        setSubjects([]);
        return;
      }
      const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, apiMsgProps);
      setSubjects(Array.isArray(data) ? data : []);
    };
    fetchSubjects();
  }, [selectedCourseId]);

  // ── API: chapters ─────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchChapters = async () => {
      if (!selectedSubjectId) {
        setChapters([]);
        return;
      }
      const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
      const data = await GET.noToken(url, apiMsgProps);
      setChapters(Array.isArray(data) ? data : []);
    };
    fetchChapters();
  }, [selectedSubjectId]);

  // ── API: topics ───────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchTopics = async () => {
      if (!Array.isArray(selectedChapterId) || selectedChapterId.length === 0) {
        setTopics([]);
        return;
      }
      const data = await POST.withToken(
        EndPoints.TopicsByChapterList,
        selectedChapterId,
        apiMsgProps
      );
      if (data && data.status_code === 200 && Array.isArray(data.data))
        setTopics(data.data);
      else setTopics([]);
    };
    fetchTopics();
  }, [selectedChapterId]);

  // ── API: question papers ──────────────────────────────────────────────────
  useEffect(() => {
    const fetchQuestionPapers = async () => {
      if (!clientBranchId || !selectedClassId || !selectedSubjectId) {
        setQuestionPapers([]);
        return;
      }
      let baseUrl = `${EndPoints.DPP_QUESTION_PAPER_V2}?branch_id=${clientBranchId}&class_id=${selectedClassId}&subject_id=${selectedSubjectId}`;
      if (Array.isArray(selectedBatchId))
        selectedBatchId.forEach((id) => (baseUrl += `&batch_id=${id}`));
      if (Array.isArray(selectedStudentGroup))
        selectedStudentGroup.forEach((id) => (baseUrl += `&student_group_ids=${id}`));
      if (Array.isArray(selectedChapterId))
        selectedChapterId.forEach((id) => (baseUrl += `&chapter_id=${id}`));
      if (Array.isArray(selectedTopicId))
        selectedTopicId.forEach((id) => (baseUrl += `&topic_id=${id}`));
      try {
        const response = await fetch(baseUrl, {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const result = await response.json();
        setQuestionPapers(
          result?.status === 200 && Array.isArray(result.data) ? result.data : []
        );
      } catch (error) {
        console.error("Error fetching question papers:", error);
        setQuestionPapers([]);
      }
    };
    fetchQuestionPapers();
  }, [
    selectedChapterId,
    selectedTopicId,
    selectedSubjectId,
    selectedClassId,
    clientBranchId,
    JSON.stringify(selectedBatchId),
    JSON.stringify(selectedStudentGroup),
  ]);

  // ── API: student groups ───────────────────────────────────────────────────
  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;
      try {
        setStudentGroupsError(null);
        const resp = await fetch(
          `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }
        const json = await resp.json();
        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        setStudentGroupsError(err.message || "Error loading student groups");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      }
    };
    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  useEffect(() => {
    setSelectedBatchId([]);
    setSelectedBatchName("");
  }, [selectedClassId]);

  useEffect(() => {
    setSelectedChapterId([]);
    setSelectedChapterName("");
  }, [selectedSubjectId]);

  useEffect(() => {
    setSelectedTopicId([]);
    setSelectedTopicName("");
  }, [selectedChapterId]);

  useEffect(() => {
    setSelectedQuestionPaperId("");
    setSelectedQuestionPaperName("");
  }, [
    selectedCourseId,
    selectedClassId,
    JSON.stringify(selectedBatchId),
    selectedSubjectId,
    selectedChapterId,
    selectedTopicId,
  ]);

  useEffect(() => {
    if (!selectedQuestionPaperId) {
      setSelectedQuestionPaperDescription("");
      setSelectedQuestionPaperCreatedBy("");
      setSelectedQuestionPaperSubjects("");
    }
  }, [selectedQuestionPaperId]);

  // Batch coordinator name: fill from the first selected batch if the API provides it
  useEffect(() => {
    if (!Array.isArray(selectedBatchId) || selectedBatchId.length === 0) {
      setCordinatorName("");
      return;
    }
    const firstBatch = batches.find((b) => b.batch_id === selectedBatchId[0]);
    setCordinatorName(
      firstBatch?.batch_coordinator_name || firstBatch?.coordinator_name || ""
    );
  }, [selectedBatchId, batches]);

  useEffect(() => {
    setDppName("");
    setDppDescription("");
    setInstructionsHtml("");
    setTestStartDate(null);
    setTestEndDate(null);
    setUploadedFile(null);
  }, [selectedCourseId, selectedClassId]);

  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [selectedCourseId]);

  const searchStudentGroups = (searchKey) => {
    let filtered = allStudentGroups;
    if (selectedCourseId)
      filtered = filtered.filter((g) => g.course_id === selectedCourseId);
    if (searchKey && searchKey.trim() !== "")
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    setStudentGroupsOptions(filtered);
  };

  const getFilteredStudentGroups = () => {
    if (!selectedCourseId) return studentGroupsOptions;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
  };

  const handleFileUpload = (file) => setUploadedFile(file);

  // Call this from QuickFileUpload with the upload API response
  const handleUploadSuccess = (resp) => {
    const id =
      resp?.parse_ques_set_id ??
      resp?.data?.parse_ques_set_id ??
      resp?.data?.[0]?.parse_ques_set_id ??
      "";
    setParseQuesSetId(id ? String(id) : "");
  };

  const toggleUploadAccordion = () => setIsOpenUpload(!isOpenUpload);

  // ── Save ──────────────────────────────────────────────────────────────────
  const handleSave = async () => {
    const minAllowed = getCurrentDateTime();

    if (!selectedCourseId) return showMessage("Please select a Course.", ErrorImg);
    if (!selectedClassId) return showMessage("Please select a Class.", ErrorImg);
    if (!selectedSubjectId) return showMessage("Please select a Subject.", ErrorImg);
    if (!selectedQuestionPaperId)
      return showMessage("Please select a Question Paper.", ErrorImg);

    if (!dppName.trim()) return showMessage("Please enter a DPP Name.", ErrorImg);
    if (!DppDescription.trim())
      return showMessage("Please enter a DPP Description.", ErrorImg);

    if (
      fillInTheBlanksSuggestions === "" ||
      fillInTheBlanksSuggestions === null ||
      fillInTheBlanksSuggestions === undefined
    )
      return showMessage(
        "Please select Fill in the Blanks Suggestions option.",
        ErrorImg
      );

    if (!testStartDate)
      return showMessage("Please select a DPP Window Start date.", ErrorImg);
    if (testStartDate < minAllowed)
      return showMessage(
        "DPP window start must be at least 15 minutes from current time. Please correct the start time before saving.",
        ErrorImg
      );
    if (!testEndDate)
      return showMessage("Please select a DPP Window End date.", ErrorImg);
    if (testEndDate <= testStartDate)
      return showMessage("DPP window end must be after the DPP window start.", ErrorImg);
    if (testEndDate < getMinEndDateTime(testStartDate))
      return showMessage(
        "DPP window end must be at least 24 hours after the start time.",
        ErrorImg
      );

    const studentGroupIds = Array.isArray(selectedStudentGroup)
      ? selectedStudentGroup
      : selectedStudentGroup
        ? [selectedStudentGroup]
        : [];
    const batchIds = Array.isArray(selectedBatchId) ? selectedBatchId : [];

    const body = {
      request: {
        ques_paper_id: selectedQuestionPaperId,
        dpp_name: dppName,
        dpp_desc: DppDescription,
        batch_id_list: batchIds,
        student_group_ids: studentGroupIds,
        dpp_window_start: testStartDate,
        dpp_window_end: testEndDate,
        client_id: clientId,
        client_branch_id: clientBranchId,
        created_by: userName,
        instructions_html: instructionsHtml,
        subject_id: selectedSubjectId || 0,
        chapter_names: selectedChapterName,
        topic_names: selectedTopicName,
        fill_in_the_blanks_suggestions: fillInTheBlanksSuggestions,
      },
      payload: {
        user_name: userName,
        client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
        screen_event_id: 72,
        screen_id: 77,
        student_id: null,
        batch_id: batchIds.length ? batchIds : null,
        subject_id: selectedSubjectId ? [selectedSubjectId] : null,
        class_id: selectedClassId ? [selectedClassId] : null,
        course_id: selectedCourseId ? [selectedCourseId] : null,
        session_id: null,
        student_group_id: studentGroupIds.length ? studentGroupIds : null,
      },
    };

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-dpp-schedule-notification/`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(body),
        }
      );
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      if (data && data.status === 200) {
        showMessage(data.message || "DPP schedule created successfully!", SucessImg);
        setTimeout(() => navigate(-1), 1000);
      } else {
        showMessage(
          "Failed to create DPP Schedule: " +
          (data?.message || data?.detail || "Unknown error"),
          ErrorImg
        );
      }
    } catch (error) {
      showMessage(`Error creating DPP schedule: ${error.message}`, ErrorImg);
    }
  };

  return (
    <div className="create-role-container dpp-scheduling-page">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Quick DPP Scheduling</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>

      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
        </div>
        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div>
                <DropDown
                  label="Select Course"
                  style={{ width: "100%" }}
                  setSelected={(selected) => {
                    const id =
                      selected && typeof selected === "object" ? selected.id : selected;
                    const course = courses.find((c) => c.course_id === id);
                    setSelectedCourseId(id ?? "");
                    setSelectedCourseName(
                      course?.course_name ||
                      (selected && typeof selected === "object" ? selected.label : "") ||
                      ""
                    );
                  }}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />
              </div>

              <div>
                <DropDown
                  key={`class-${selectedCourseId}`}
                  label="Select Class"
                  style={{ width: "100%" }}
                  value={selectedClassId}
                  setSelected={(id) => {
                    const classOption = Array.isArray(classes)
                      ? classes.find((cls) => cls.class_id === id)
                      : undefined;
                    setSelectedClassId(classOption ? classOption.class_id : "");
                    setSelectedClassName(classOption ? classOption.class_name : "");
                  }}
                  options={classes.map((cls) => ({
                    label: cls.class_name,
                    id: cls.class_id,
                  }))}
                  isRequired={true}
                />
              </div>

              <div>
                <MultiSelectSearchDropdown
                  label="Batch Name"
                  width="100%"
                  selected={selectedBatchId}
                  setSelected={(selectedIds) => {
                    setSelectedBatchId(selectedIds);
                    setSelectedBatchName(
                      Array.isArray(selectedIds) && selectedIds.length > 0
                        ? batches
                          .filter((b) => selectedIds.includes(b.batch_id))
                          .map((b) => b.batch_name)
                          .join(", ")
                        : ""
                    );
                  }}
                  options={batches.map((batch) => ({
                    label: batch.batch_name,
                    id: batch.batch_id,
                  }))}
                  isRequired={false}
                  placeholder="Select Batch..."
                  singleSelect={false}
                />
              </div>

              <div>
                <MultiSelectSearchDropdown
                  label="Student Group"
                  width="100%"
                  selected={selectedStudentGroup}
                  setSelected={setSelectedStudentGroup}
                  options={getFilteredStudentGroups().map((g) => ({
                    label: g.label,
                    id: g.id,
                  }))}
                  isRequired={false}
                  placeholder="Select Student Group..."
                  singleSelect={false}
                  onSearchInputChange={searchStudentGroups}
                />
                {studentGroupsError && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {studentGroupsError}
                  </div>
                )}
              </div>

              <div>
                <DropDown
                  key={`subject-${selectedCourseId}`}
                  label="Select Subject"
                  style={{ width: "100%" }}
                  value={selectedSubjectId}
                  setSelected={(id) => {
                    const subjectOption = Array.isArray(subjects)
                      ? subjects.find((s) => s.subject_id === id)
                      : undefined;
                    setSelectedSubjectId(subjectOption ? subjectOption.subject_id : "");
                    setSelectedSubjectName(subjectOption ? subjectOption.subject_name : "");
                  }}
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                />
              </div>

              <div>
                <MultiSelectSearchDropdown
                  label="Select Chapter (Optional)"
                  width="100%"
                  selected={selectedChapterId}
                  setSelected={(selectedIds) => {
                    setSelectedChapterId(selectedIds);
                    setSelectedChapterName(
                      Array.isArray(selectedIds) && selectedIds.length > 0
                        ? chapters
                          .filter((c) => selectedIds.includes(c.chapter_id))
                          .map((c) => c.chapter_name)
                          .join(", ")
                        : ""
                    );
                  }}
                  options={chapters.map((chapter) => ({
                    label: chapter.chapter_name,
                    id: chapter.chapter_id,
                  }))}
                  isRequired={false}
                />
              </div>

              <div>
                <MultiSelectSearchDropdown
                  label="Select Topic (Optional)"
                  width="100%"
                  selected={selectedTopicId}
                  setSelected={(selectedIds) => {
                    setSelectedTopicId(selectedIds);
                    setSelectedTopicName(
                      Array.isArray(selectedIds) && selectedIds.length > 0
                        ? (Array.isArray(topics) ? topics : [])
                          .filter((t) => selectedIds.includes(t.topic_id))
                          .map((t) => t.topic_name)
                          .join(", ")
                        : ""
                    );
                  }}
                  options={
                    Array.isArray(topics)
                      ? topics.map((topic) => ({
                        label: topic.topic_name,
                        id: topic.topic_id,
                      }))
                      : []
                  }
                  isRequired={false}
                />
              </div>

              <div>
                <DropDown
                  key={`qp-${selectedCourseId}-${selectedClassId}-${(selectedBatchId || []).join(",")}-${selectedSubjectId}-${(selectedChapterId || []).join(",")}-${(selectedTopicId || []).join(",")}`}
                  label="Question Paper Name"
                  style={{ width: "100%" }}
                  setSelected={(selectedQPId) => {
                    const qpOption = Array.isArray(questionPapers)
                      ? questionPapers.find((qp) => qp.ques_paper_id === selectedQPId)
                      : undefined;
                    if (qpOption) {
                      setSelectedQuestionPaperId(qpOption.ques_paper_id);
                      setSelectedQuestionPaperName(qpOption.ques_paper_name);
                      setSelectedQuestionPaperDescription(qpOption.description);
                      setSelectedQuestionPaperCreatedBy(qpOption.created_by);
                      setSelectedQuestionPaperSubjects(qpOption.subject_name || "");
                    } else {
                      setSelectedQuestionPaperId("");
                      setSelectedQuestionPaperName("");
                      setSelectedQuestionPaperDescription("");
                      setSelectedQuestionPaperCreatedBy("");
                      setSelectedQuestionPaperSubjects("");
                    }
                  }}
                  options={questionPapers.map((qp) => ({
                    label: qp.ques_paper_name,
                    id: qp.ques_paper_id,
                  }))}
                  isRequired={true}
                  minheight="250px"
                  Height="auto"
                  OverFlow="auto"
                />
              </div>

              <div>
                <InputComponent
                  label="Question Paper Subjects"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperSubjects}
                  isRequired={false}
                  disable={true}
                />
              </div>

              <div>
                <InputComponent
                  label="Question Paper Created By"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperCreatedBy}
                  isRequired={false}
                  disable={true}
                />
              </div>

              <div style={{ gridColumn: "2 / 4" }}>
                <InputComponent
                  label="Question Paper Description"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>

              <div>
                <FormInputs
                  label="DPP Name"
                  value={dppName}
                  onChange={(e) => setDppName(e.target.value)}
                  placeholder="Enter DPP name"
                  style={{ width: "100%" }}
                  required
                />
              </div>

              <div>
                <FormInputs
                  label="Description"
                  value={DppDescription}
                  onChange={(e) => setDppDescription(e.target.value)}
                  placeholder="Enter Description"
                  style={{ width: "100%" }}
                  required
                />
              </div>

              <div>
                <DropDown
                  label="Fill in the blanks - Suggestions"
                  style={{ width: "100%" }}
                  setSelected={(selected) => setFillInTheBlanksSuggestions(selected)}
                  options={[
                    { label: "Enable", id: true },
                    { label: "Disable", id: false },
                  ]}
                  isRequired={true}
                />
              </div>

              <div>
                <FormInputs
                  label="Batch Coordinator Name"
                  style={{ width: "100%" }}
                  value={CordinatorName}
                  isRequired={false}
                  disabled={true}
                />
              </div>

              <div>
                <FormInputs
                  label="DPP Window Start"
                  style={{ width: "100%" }}
                  value={testStartDate || ""}
                  isRequired={false}
                  disable={false}
                  type="datetime-local"
                  min={getCurrentDateTime()}
                  onChange={(e) => {
                    const newStartDate = e.target.value;
                    setTestStartDate(newStartDate);
                    if (newStartDate) setTestEndDate(getMinEndDateTime(newStartDate));
                  }}
                  required
                />
              </div>

              <div>
                <FormInputs
                  label="DPP Window End"
                  style={{ width: "100%" }}
                  value={testEndDate || ""}
                  isRequired={false}
                  disable={false}
                  type="datetime-local"
                  min={
                    testStartDate
                      ? getMinEndDateTime(testStartDate)
                      : getCurrentDateTime()
                  }
                  onChange={(e) => setTestEndDate(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="dpp-instructions-wrapper">
            <TextEditor
              templates={testTemplates}
              value={instructionsHtml}
              setValue={setInstructionsHtml}
            />
          </div>
        </div>
      </div>

      {/* ── UPLOAD FILE Section ───────────────────────────────────────────── */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>UPLOAD Question Paper</label>
          </div>
          <div className="accordion-btn" onClick={toggleUploadAccordion}>
            {isOpenUpload ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenUpload && (
          <div className="accordion-content">
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: "20px",
                padding: "15px",
              }}
            >
              <QuickFileUpload
                label="Select File"
                onFileSelect={handleFileUpload}
                onUploadSuccess={handleUploadSuccess}
              />
              <div className="file-upload-instructions" style={{ fontSize: "14px" }}>
                <div
                  onClick={toggleInstructions}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  <strong>Instructions for Uploading:</strong>
                  <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {isOpenInstructions ? "−" : "+"}
                  </span>
                </div>

                {isOpenInstructions && (
                  <div style={{ marginTop: "8px" }}>
                    <p>
                      1. Ensure the file format is <strong>.docx</strong> or{" "}
                      <strong>.doc</strong>. Other formats, including PDFs, are not
                      supported.
                    </p>
                    <p>
                      2. Do not include blank spaces in the file name. Use underscores
                      (_) or hyphens (-) instead.
                    </p>
                    <p>
                      3. Question numbering format: Use hash (#) before the number and
                      dot (.) after the number. Example - #1., #11., #111.
                    </p>
                    <p>4. Always keep one space after the dot (.) in question numbering.</p>
                    <p>
                      5. Option numbering format: Use (@) before the number and enclose
                      it in brackets (). Example - (@1), (@2). Mark correct answers with
                      an asterisk (*). Example - (@*1), (@*4).
                    </p>
                    <p>6. Do not use alphabets like (a, b, c, d) for options.</p>
                    <p>
                      7. Do not use subscript or superscript formatting (e.g., A
                      <sub>2</sub> or A<sup>2</sup> is not allowed). Instead, use the
                      insert equation feature. Example: A=πr^2.
                    </p>
                    <p>
                      8. Adding images/pictures: .emf format is not supported. Use .png
                      or .jpg formats.
                    </p>
                    <p>9. Always keep one blank line between questions and options.</p>
                    <p>
                      10. Word limit on Solution is{" "}
                      <span style={{ fontWeight: "bold" }}>5000</span> characters.
                    </p>
                  </div>
                )}
              </div>
              <QuickDPPSchedulingTable
                parseQuesSetId={parseQuesSetId}
                headers={tableHeaders}
                data={tableRows}
                loading={tableLoading}
                error={tableError}
                onRefresh={() => setRefreshKey((k) => k + 1)}
                setMessageBox={setMessageBox}
                setIsMessageBoxVisible={setIsMessageBoxVisible}
                setActiveImg={setActiveImg}
                dataClient={dataClient}
              />
            </div>
          </div>
        )}
      </div>
            <div className="create-ques-paper-ques-bank-preview-valiedate">
        <button onClick={handlePreview}> Preview </button>
      </div>

      {/* ── Preview Selected Questions modal ─────────────────────────────── */}
         {isPreviewOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "66vw",
              height: "80vh",
            }}
          >
            <div
              onClick={() => setIsPreviewOpen(false)}
              title="Close"
              style={{
                position: "absolute",
                top: "-10px",
                right: "-38px",
                color: "#fff",
                fontSize: "30px",
                cursor: "pointer",
                userSelect: "none",
                zIndex: 1001,
              }}
            >
              ×
            </div>

            <div
              style={{
                background: "#fff",
                width: "100%",
                height: "100%",
                borderRadius: "14px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column",
                padding: "30px 20px 0 35px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ display: "flex", alignItems: "baseline", gap: "12px" }}>
                <span style={{ fontSize: "18px", fontWeight: "bold", color: "#2F2E40" }}>
                  Preview Selected Questions
                </span>
                <span
                  onClick={() => setShowOptions((p) => !p)}
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "#6A6A6A",
                    userSelect: "none",
                  }}
                >
                  {showOptions ? "Hide Options" : "Show Options"}
                </span>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px 20px",
                  marginTop: "14px",
                  paddingBottom: "12px",
                  borderBottom: "1px solid #ccc",
                  fontSize: "14px",
                  color: "#2F2E40",
                }}
              >
              </div>

              <div style={{ flex: 1, overflowY: "auto", padding: "10px 10px 20px 0" }}>
                {tableRows.map((row, index) => {
                  const q = row.raw;
                  const opts = getOptions(q);
                  return (
                    <div key={row.id} style={{ marginBottom: "22px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "6px",
                          fontSize: "14px",
                          color: "#424242",
                          lineHeight: "22px",
                        }}
                      >
                        <span>{q?.ques_no ?? index + 1}.</span>
                        <span>{renderContent(q?.question_text)}</span>
                      </div>

                      {showOptions && opts.length > 0 && (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "14px 20px",
                            marginTop: "12px",
                            paddingLeft: "22px",
                            fontSize: "14px",
                          }}
                        >
                          {opts.map((o, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                gap: "6px",
                                color: o.correct ? "#2E7D32" : "#424242",
                                fontWeight: o.correct ? "bold" : "normal",
                              }}
                            >
                              <span>{String.fromCharCode(97 + i)}.</span>
                              <span>{renderContent(o.text)}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickDPPSchedulingDashboard;



















// import React, { useState, useEffect } from "react";
// import DropDown from "../../Components/Shared/Dropdown/Dropdown";
// import InputComponent from "../../Components/Shared/FormInputs/FormInputs";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import TextEditor from "../Landing/components/TextEditor";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import SucessImg from "../../Assets/Images/CommanImages/success.png";
// import MultiSelectSearchDropdown from "../CreateQuestionsPaper/SearchDropDown/MultiSelectSearchDropdown";
// import { POST, GET } from "../../Api/HttpsMethods";
// import EndPoints from "../../Api/EndPoints";
// import { useNavigate } from "react-router-dom";
// import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
// import QuickFileUpload from "./QuickFileUpload";
// import QuickDPPSchedulingTable from "./QuickDPPSchedulingTable";

// // TODO: remove this default once QuickFileUpload calls onUploadSuccess with a real id.
// const DEFAULT_PARSE_QUES_SET_ID = "2533";

// const QuickDPPSchedulingDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const navigate = useNavigate();
//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const accessToken = localStorage.getItem("other");

//   const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] = useState("");
//   const [selectedChapterId, setSelectedChapterId] = useState([]);
//   const [selectedChapterName, setSelectedChapterName] = useState("");
//   const [selectedTopicId, setSelectedTopicId] = useState([]);
//   const [selectedTopicName, setSelectedTopicName] = useState("");
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
//   const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
//   const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
//   const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [testStartDate, setTestStartDate] = useState(null);
//   const [testEndDate, setTestEndDate] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [questionPapers, setQuestionPapers] = useState([]);
//   const [batches, setBatches] = useState([]);
//   const [dppName, setDppName] = useState("");
//   const [DppDescription, setDppDescription] = useState("");
//   const [CordinatorName, setCordinatorName] = useState("");
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [selectedBatchId, setSelectedBatchId] = useState([]);
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [selectedSubjectId, setSelectedSubjectId] = useState("");
//   const [selectedSubjectName, setSelectedSubjectName] = useState("");
//   const [selectedClassId, setSelectedClassId] = useState("");
//   const [selectedClassName, setSelectedClassName] = useState("");
//   const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
//   const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
//   const [allStudentGroups, setAllStudentGroups] = useState([]);
//   const [studentGroupsError, setStudentGroupsError] = useState(null);
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);
//   const [fillInTheBlanksSuggestions, setFillInTheBlanksSuggestions] = useState("");
//   const [isOpenUpload, setIsOpenUpload] = useState(true);
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [parseQuesSetId, setParseQuesSetId] = useState(DEFAULT_PARSE_QUES_SET_ID);
//   const [isOpenInstructions, setIsOpenInstructions] = useState(false);
//   const toggleInstructions = () => setIsOpenInstructions((prev) => !prev);

//   const showMessage = (text, img) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{text}</span>
//         </div>
//       </div>
//     );
//     setActiveImg(img);
//     setIsMessageBoxVisible(true);
//   };

//   const apiMsgProps = { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg };

//   const formatDateTime = (d) => {
//     const year = d.getFullYear();
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const day = String(d.getDate()).padStart(2, "0");
//     const hours = String(d.getHours()).padStart(2, "0");
//     const mins = String(d.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${mins}`;
//   };

//   const getCurrentDateTime = () => {
//     const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
//     base.setMinutes(base.getMinutes() + 15);
//     return formatDateTime(base);
//   };

//   // start + 24 hours
//   const getMinEndDateTime = (startDateTime) => {
//     if (!startDateTime) return getCurrentDateTime();
//     return formatDateTime(
//       new Date(new Date(startDateTime).getTime() + 24 * 60 * 60 * 1000)
//     );
//   };

//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-current-datetime/`, {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         const data = await response.json();
//         if (data?.status === 200 && data?.data) {
//           const { current_date, current_time } = data.data;
//           setServerCurrentTime(`${current_date}T${current_time}`);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         setServerCurrentTime(new Date().toISOString());
//       }
//     };
//     fetchServerTime();
//   }, []);

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     const fetchTestTemplates = async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         setTestTemplates(await response.json());
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//         showMessage(`Error fetching test templates: ${error.message}`, ErrorImg);
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   // ── API: courses ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`, {
//           headers: { accept: "application/json" },
//         });
//         const data = await response.json();
//         setCourses(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };
//     fetchCourses();
//   }, []);

//   // ── API: classes ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchClasses = async () => {
//       const data = await GET.noToken(EndPoints.GetClasses, apiMsgProps);
//       if (Array.isArray(data)) setClasses(data);
//     };
//     fetchClasses();
//   }, []);

//   // ── API: batches ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (!selectedCourseId) {
//         setBatches([]);
//         return;
//       }
//       const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, apiMsgProps);
//       if (Array.isArray(data?.[0])) {
//         setBatches(
//           selectedClassId
//             ? data[0].filter(
//               (batch) => String(batch.class_id) === String(selectedClassId)
//             )
//             : data[0]
//         );
//       } else setBatches([]);
//     };
//     fetchBatches();
//   }, [selectedCourseId, selectedClassId]);

//   // ── API: subjects ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (!selectedCourseId) {
//         setSubjects([]);
//         return;
//       }
//       const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, apiMsgProps);
//       setSubjects(Array.isArray(data) ? data : []);
//     };
//     fetchSubjects();
//   }, [selectedCourseId]);

//   // ── API: chapters ─────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchChapters = async () => {
//       if (!selectedSubjectId) {
//         setChapters([]);
//         return;
//       }
//       const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
//       const data = await GET.noToken(url, apiMsgProps);
//       setChapters(Array.isArray(data) ? data : []);
//     };
//     fetchChapters();
//   }, [selectedSubjectId]);

//   // ── API: topics ───────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchTopics = async () => {
//       if (!Array.isArray(selectedChapterId) || selectedChapterId.length === 0) {
//         setTopics([]);
//         return;
//       }
//       const data = await POST.withToken(
//         EndPoints.TopicsByChapterList,
//         selectedChapterId,
//         apiMsgProps
//       );
//       if (data && data.status_code === 200 && Array.isArray(data.data))
//         setTopics(data.data);
//       else setTopics([]);
//     };
//     fetchTopics();
//   }, [selectedChapterId]);

//   // ── API: question papers ──────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchQuestionPapers = async () => {
//       if (!clientBranchId || !selectedClassId || !selectedSubjectId) {
//         setQuestionPapers([]);
//         return;
//       }
//       let baseUrl = `${EndPoints.DPP_QUESTION_PAPER_V2}?branch_id=${clientBranchId}&class_id=${selectedClassId}&subject_id=${selectedSubjectId}`;
//       if (Array.isArray(selectedBatchId))
//         selectedBatchId.forEach((id) => (baseUrl += `&batch_id=${id}`));
//       if (Array.isArray(selectedStudentGroup))
//         selectedStudentGroup.forEach((id) => (baseUrl += `&student_group_ids=${id}`));
//       if (Array.isArray(selectedChapterId))
//         selectedChapterId.forEach((id) => (baseUrl += `&chapter_id=${id}`));
//       if (Array.isArray(selectedTopicId))
//         selectedTopicId.forEach((id) => (baseUrl += `&topic_id=${id}`));
//       try {
//         const response = await fetch(baseUrl, {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         const result = await response.json();
//         setQuestionPapers(
//           result?.status === 200 && Array.isArray(result.data) ? result.data : []
//         );
//       } catch (error) {
//         console.error("Error fetching question papers:", error);
//         setQuestionPapers([]);
//       }
//     };
//     fetchQuestionPapers();
//   }, [
//     selectedChapterId,
//     selectedTopicId,
//     selectedSubjectId,
//     selectedClassId,
//     clientBranchId,
//     JSON.stringify(selectedBatchId),
//     JSON.stringify(selectedStudentGroup),
//   ]);

//   // ── API: student groups ───────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchStudentGroups = async () => {
//       if (!clientBranchId) return;
//       try {
//         setStudentGroupsError(null);
//         const resp = await fetch(
//           `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`,
//           {
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         if (resp.status === 401 || resp.status === 403) {
//           setStudentGroupsError("Not authenticated. Please login.");
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//           return;
//         }
//         const json = await resp.json();
//         if (
//           json &&
//           (json.status === "200" || json.status === 200) &&
//           Array.isArray(json.data)
//         ) {
//           const options = json.data.map((group) => ({
//             id: group.student_group_id,
//             label: group.student_group_name,
//             session_id: group.session_id || "",
//             course_id: group.course_id || "",
//           }));
//           setStudentGroupsOptions(options);
//           setAllStudentGroups(options);
//         } else {
//           setStudentGroupsOptions([]);
//           setAllStudentGroups([]);
//         }
//       } catch (err) {
//         setStudentGroupsError(err.message || "Error loading student groups");
//         setStudentGroupsOptions([]);
//         setAllStudentGroups([]);
//       }
//     };
//     fetchStudentGroups();
//   }, [clientBranchId, accessToken]);

//   useEffect(() => {
//     setSelectedBatchId([]);
//     setSelectedBatchName("");
//   }, [selectedClassId]);

//   useEffect(() => {
//     setSelectedChapterId([]);
//     setSelectedChapterName("");
//   }, [selectedSubjectId]);

//   useEffect(() => {
//     setSelectedTopicId([]);
//     setSelectedTopicName("");
//   }, [selectedChapterId]);

//   useEffect(() => {
//     setSelectedQuestionPaperId("");
//     setSelectedQuestionPaperName("");
//   }, [
//     selectedCourseId,
//     selectedClassId,
//     JSON.stringify(selectedBatchId),
//     selectedSubjectId,
//     selectedChapterId,
//     selectedTopicId,
//   ]);

//   useEffect(() => {
//     if (!selectedQuestionPaperId) {
//       setSelectedQuestionPaperDescription("");
//       setSelectedQuestionPaperCreatedBy("");
//       setSelectedQuestionPaperSubjects("");
//     }
//   }, [selectedQuestionPaperId]);

//   // Batch coordinator name: fill from the first selected batch if the API provides it
//   useEffect(() => {
//     if (!Array.isArray(selectedBatchId) || selectedBatchId.length === 0) {
//       setCordinatorName("");
//       return;
//     }
//     const firstBatch = batches.find((b) => b.batch_id === selectedBatchId[0]);
//     setCordinatorName(
//       firstBatch?.batch_coordinator_name || firstBatch?.coordinator_name || ""
//     );
//   }, [selectedBatchId, batches]);

//   useEffect(() => {
//     setDppName("");
//     setDppDescription("");
//     setInstructionsHtml("");
//     setTestStartDate(null);
//     setTestEndDate(null);
//     setUploadedFile(null);
//   }, [selectedCourseId, selectedClassId]);

//   useEffect(() => {
//     setSelectedStudentGroup([]);
//   }, [selectedCourseId]);

//   const searchStudentGroups = (searchKey) => {
//     let filtered = allStudentGroups;
//     if (selectedCourseId)
//       filtered = filtered.filter((g) => g.course_id === selectedCourseId);
//     if (searchKey && searchKey.trim() !== "")
//       filtered = filtered.filter((g) =>
//         g.label.toLowerCase().includes(searchKey.toLowerCase())
//       );
//     setStudentGroupsOptions(filtered);
//   };

//   const getFilteredStudentGroups = () => {
//     if (!selectedCourseId) return studentGroupsOptions;
//     return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
//   };

//   const handleFileUpload = (file) => setUploadedFile(file);

//   // Call this from QuickFileUpload with the upload API response
//   const handleUploadSuccess = (resp) => {
//     const id =
//       resp?.parse_ques_set_id ??
//       resp?.data?.parse_ques_set_id ??
//       resp?.data?.[0]?.parse_ques_set_id ??
//       "";
//     setParseQuesSetId(id ? String(id) : "");
//   };

//   const toggleUploadAccordion = () => setIsOpenUpload(!isOpenUpload);

//   // ── Save ──────────────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     const minAllowed = getCurrentDateTime();

//     if (!selectedCourseId) return showMessage("Please select a Course.", ErrorImg);
//     if (!selectedClassId) return showMessage("Please select a Class.", ErrorImg);
//     if (!selectedSubjectId) return showMessage("Please select a Subject.", ErrorImg);
//     if (!selectedQuestionPaperId)
//       return showMessage("Please select a Question Paper.", ErrorImg);

//     if (!dppName.trim()) return showMessage("Please enter a DPP Name.", ErrorImg);
//     if (!DppDescription.trim())
//       return showMessage("Please enter a DPP Description.", ErrorImg);

//     if (
//       fillInTheBlanksSuggestions === "" ||
//       fillInTheBlanksSuggestions === null ||
//       fillInTheBlanksSuggestions === undefined
//     )
//       return showMessage(
//         "Please select Fill in the Blanks Suggestions option.",
//         ErrorImg
//       );

//     if (!testStartDate)
//       return showMessage("Please select a DPP Window Start date.", ErrorImg);
//     if (testStartDate < minAllowed)
//       return showMessage(
//         "DPP window start must be at least 15 minutes from current time. Please correct the start time before saving.",
//         ErrorImg
//       );
//     if (!testEndDate)
//       return showMessage("Please select a DPP Window End date.", ErrorImg);
//     if (testEndDate <= testStartDate)
//       return showMessage("DPP window end must be after the DPP window start.", ErrorImg);
//     if (testEndDate < getMinEndDateTime(testStartDate))
//       return showMessage(
//         "DPP window end must be at least 24 hours after the start time.",
//         ErrorImg
//       );

//     const studentGroupIds = Array.isArray(selectedStudentGroup)
//       ? selectedStudentGroup
//       : selectedStudentGroup
//         ? [selectedStudentGroup]
//         : [];
//     const batchIds = Array.isArray(selectedBatchId) ? selectedBatchId : [];

//     const body = {
//       request: {
//         ques_paper_id: selectedQuestionPaperId,
//         dpp_name: dppName,
//         dpp_desc: DppDescription,
//         batch_id_list: batchIds,
//         student_group_ids: studentGroupIds,
//         dpp_window_start: testStartDate,
//         dpp_window_end: testEndDate,
//         client_id: clientId,
//         client_branch_id: clientBranchId,
//         created_by: userName,
//         instructions_html: instructionsHtml,
//         subject_id: selectedSubjectId || 0,
//         chapter_names: selectedChapterName,
//         topic_names: selectedTopicName,
//         fill_in_the_blanks_suggestions: fillInTheBlanksSuggestions,
//       },
//       payload: {
//         user_name: userName,
//         client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
//         screen_event_id: 72,
//         screen_id: 77,
//         student_id: null,
//         batch_id: batchIds.length ? batchIds : null,
//         subject_id: selectedSubjectId ? [selectedSubjectId] : null,
//         class_id: selectedClassId ? [selectedClassId] : null,
//         course_id: selectedCourseId ? [selectedCourseId] : null,
//         session_id: null,
//         student_group_id: studentGroupIds.length ? studentGroupIds : null,
//       },
//     };

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/create-dpp-schedule-notification/`,
//         {
//           method: "POST",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(body),
//         }
//       );
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       if (data && data.status === 200) {
//         showMessage(data.message || "DPP schedule created successfully!", SucessImg);
//         setTimeout(() => navigate(-1), 1000);
//       } else {
//         showMessage(
//           "Failed to create DPP Schedule: " +
//           (data?.message || data?.detail || "Unknown error"),
//           ErrorImg
//         );
//       }
//     } catch (error) {
//       showMessage(`Error creating DPP schedule: ${error.message}`, ErrorImg);
//     }
//   };

//   return (
//     <div className="create-role-container dpp-scheduling-page">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Quick DPP Scheduling</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>QUESTION PAPER DETAIL</label>
//           </div>
//         </div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div>
//                 <DropDown
//                   label="Select Course"
//                   style={{ width: "100%" }}
//                   setSelected={(selected) => {
//                     const id =
//                       selected && typeof selected === "object" ? selected.id : selected;
//                     const course = courses.find((c) => c.course_id === id);
//                     setSelectedCourseId(id ?? "");
//                     setSelectedCourseName(
//                       course?.course_name ||
//                       (selected && typeof selected === "object" ? selected.label : "") ||
//                       ""
//                     );
//                   }}
//                   options={courses.map((course) => ({
//                     label: course.course_name,
//                     id: course.course_id,
//                   }))}
//                   isRequired={true}
//                 />
//               </div>

//               <div>
//                 <DropDown
//                   key={`class-${selectedCourseId}`}
//                   label="Select Class"
//                   style={{ width: "100%" }}
//                   value={selectedClassId}
//                   setSelected={(id) => {
//                     const classOption = Array.isArray(classes)
//                       ? classes.find((cls) => cls.class_id === id)
//                       : undefined;
//                     setSelectedClassId(classOption ? classOption.class_id : "");
//                     setSelectedClassName(classOption ? classOption.class_name : "");
//                   }}
//                   options={classes.map((cls) => ({
//                     label: cls.class_name,
//                     id: cls.class_id,
//                   }))}
//                   isRequired={true}
//                 />
//               </div>

//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Batch Name"
//                   width="100%"
//                   selected={selectedBatchId}
//                   setSelected={(selectedIds) => {
//                     setSelectedBatchId(selectedIds);
//                     setSelectedBatchName(
//                       Array.isArray(selectedIds) && selectedIds.length > 0
//                         ? batches
//                           .filter((b) => selectedIds.includes(b.batch_id))
//                           .map((b) => b.batch_name)
//                           .join(", ")
//                         : ""
//                     );
//                   }}
//                   options={batches.map((batch) => ({
//                     label: batch.batch_name,
//                     id: batch.batch_id,
//                   }))}
//                   isRequired={false}
//                   placeholder="Select Batch..."
//                   singleSelect={false}
//                 />
//               </div>

//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Student Group"
//                   width="100%"
//                   selected={selectedStudentGroup}
//                   setSelected={setSelectedStudentGroup}
//                   options={getFilteredStudentGroups().map((g) => ({
//                     label: g.label,
//                     id: g.id,
//                   }))}
//                   isRequired={false}
//                   placeholder="Select Student Group..."
//                   singleSelect={false}
//                   onSearchInputChange={searchStudentGroups}
//                 />
//                 {studentGroupsError && (
//                   <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
//                     {studentGroupsError}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <DropDown
//                   key={`subject-${selectedCourseId}`}
//                   label="Select Subject"
//                   style={{ width: "100%" }}
//                   value={selectedSubjectId}
//                   setSelected={(id) => {
//                     const subjectOption = Array.isArray(subjects)
//                       ? subjects.find((s) => s.subject_id === id)
//                       : undefined;
//                     setSelectedSubjectId(subjectOption ? subjectOption.subject_id : "");
//                     setSelectedSubjectName(subjectOption ? subjectOption.subject_name : "");
//                   }}
//                   options={subjects.map((subject) => ({
//                     label: subject.subject_name,
//                     id: subject.subject_id,
//                   }))}
//                 />
//               </div>

//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Select Chapter (Optional)"
//                   width="100%"
//                   selected={selectedChapterId}
//                   setSelected={(selectedIds) => {
//                     setSelectedChapterId(selectedIds);
//                     setSelectedChapterName(
//                       Array.isArray(selectedIds) && selectedIds.length > 0
//                         ? chapters
//                           .filter((c) => selectedIds.includes(c.chapter_id))
//                           .map((c) => c.chapter_name)
//                           .join(", ")
//                         : ""
//                     );
//                   }}
//                   options={chapters.map((chapter) => ({
//                     label: chapter.chapter_name,
//                     id: chapter.chapter_id,
//                   }))}
//                   isRequired={false}
//                 />
//               </div>

//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Select Topic (Optional)"
//                   width="100%"
//                   selected={selectedTopicId}
//                   setSelected={(selectedIds) => {
//                     setSelectedTopicId(selectedIds);
//                     setSelectedTopicName(
//                       Array.isArray(selectedIds) && selectedIds.length > 0
//                         ? (Array.isArray(topics) ? topics : [])
//                           .filter((t) => selectedIds.includes(t.topic_id))
//                           .map((t) => t.topic_name)
//                           .join(", ")
//                         : ""
//                     );
//                   }}
//                   options={
//                     Array.isArray(topics)
//                       ? topics.map((topic) => ({
//                         label: topic.topic_name,
//                         id: topic.topic_id,
//                       }))
//                       : []
//                   }
//                   isRequired={false}
//                 />
//               </div>

//               <div>
//                 <DropDown
//                   key={`qp-${selectedCourseId}-${selectedClassId}-${(selectedBatchId || []).join(",")}-${selectedSubjectId}-${(selectedChapterId || []).join(",")}-${(selectedTopicId || []).join(",")}`}
//                   label="Question Paper Name"
//                   style={{ width: "100%" }}
//                   setSelected={(selectedQPId) => {
//                     const qpOption = Array.isArray(questionPapers)
//                       ? questionPapers.find((qp) => qp.ques_paper_id === selectedQPId)
//                       : undefined;
//                     if (qpOption) {
//                       setSelectedQuestionPaperId(qpOption.ques_paper_id);
//                       setSelectedQuestionPaperName(qpOption.ques_paper_name);
//                       setSelectedQuestionPaperDescription(qpOption.description);
//                       setSelectedQuestionPaperCreatedBy(qpOption.created_by);
//                       setSelectedQuestionPaperSubjects(qpOption.subject_name || "");
//                     } else {
//                       setSelectedQuestionPaperId("");
//                       setSelectedQuestionPaperName("");
//                       setSelectedQuestionPaperDescription("");
//                       setSelectedQuestionPaperCreatedBy("");
//                       setSelectedQuestionPaperSubjects("");
//                     }
//                   }}
//                   options={questionPapers.map((qp) => ({
//                     label: qp.ques_paper_name,
//                     id: qp.ques_paper_id,
//                   }))}
//                   isRequired={true}
//                   minheight="250px"
//                   Height="auto"
//                   OverFlow="auto"
//                 />
//               </div>

//               <div>
//                 <InputComponent
//                   label="Question Paper Subjects"
//                   style={{ width: "100%" }}
//                   value={selectedQuestionPaperSubjects}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>

//               <div>
//                 <InputComponent
//                   label="Question Paper Created By"
//                   style={{ width: "100%" }}
//                   value={selectedQuestionPaperCreatedBy}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>

//               <div style={{ gridColumn: "2 / 4" }}>
//                 <InputComponent
//                   label="Question Paper Description"
//                   style={{ width: "100%" }}
//                   value={selectedQuestionPaperDescription}
//                   isRequired={false}
//                   disable={true}
//                 />
//               </div>

//               <div>
//                 <FormInputs
//                   label="DPP Name"
//                   value={dppName}
//                   onChange={(e) => setDppName(e.target.value)}
//                   placeholder="Enter DPP name"
//                   style={{ width: "100%" }}
//                   required
//                 />
//               </div>

//               <div>
//                 <FormInputs
//                   label="Description"
//                   value={DppDescription}
//                   onChange={(e) => setDppDescription(e.target.value)}
//                   placeholder="Enter Description"
//                   style={{ width: "100%" }}
//                   required
//                 />
//               </div>

//               <div>
//                 <DropDown
//                   label="Fill in the blanks - Suggestions"
//                   style={{ width: "100%" }}
//                   setSelected={(selected) => setFillInTheBlanksSuggestions(selected)}
//                   options={[
//                     { label: "Enable", id: true },
//                     { label: "Disable", id: false },
//                   ]}
//                   isRequired={true}
//                 />
//               </div>

//               <div>
//                 <FormInputs
//                   label="Batch Coordinator Name"
//                   style={{ width: "100%" }}
//                   value={CordinatorName}
//                   isRequired={false}
//                   disabled={true}
//                 />
//               </div>

//               <div>
//                 <FormInputs
//                   label="DPP Window Start"
//                   style={{ width: "100%" }}
//                   value={testStartDate || ""}
//                   isRequired={false}
//                   disable={false}
//                   type="datetime-local"
//                   min={getCurrentDateTime()}
//                   onChange={(e) => {
//                     const newStartDate = e.target.value;
//                     setTestStartDate(newStartDate);
//                     if (newStartDate) setTestEndDate(getMinEndDateTime(newStartDate));
//                   }}
//                   required
//                 />
//               </div>

//               <div>
//                 <FormInputs
//                   label="DPP Window End"
//                   style={{ width: "100%" }}
//                   value={testEndDate || ""}
//                   isRequired={false}
//                   disable={false}
//                   type="datetime-local"
//                   min={
//                     testStartDate
//                       ? getMinEndDateTime(testStartDate)
//                       : getCurrentDateTime()
//                   }
//                   onChange={(e) => setTestEndDate(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="dpp-instructions-wrapper">
//             <TextEditor
//               templates={testTemplates}
//               value={instructionsHtml}
//               setValue={setInstructionsHtml}
//             />
//           </div>
//         </div>
//       </div>

//       {/* ── UPLOAD FILE Section ───────────────────────────────────────────── */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>UPLOAD Question Paper</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleUploadAccordion}>
//             {isOpenUpload ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenUpload && (
//           <div className="accordion-content">
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr",
//                 gap: "20px",
//                 padding: "15px",
//               }}
//             >
//               <QuickFileUpload
//                 label="Select File"
//                 onFileSelect={handleFileUpload}
//                 onUploadSuccess={handleUploadSuccess}
//               />
//               <div className="file-upload-instructions" style={{ fontSize: "14px" }}>
//                 <div
//                   onClick={toggleInstructions}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     cursor: "pointer",
//                     userSelect: "none",
//                   }}
//                 >
//                   <strong>Instructions for Uploading:</strong>
//                   <span style={{ fontSize: "18px", fontWeight: "bold" }}>
//                     {isOpenInstructions ? "−" : "+"}
//                   </span>
//                 </div>

//                 {isOpenInstructions && (
//                   <div style={{ marginTop: "8px" }}>
//                     <p>
//                       1. Ensure the file format is <strong>.docx</strong> or{" "}
//                       <strong>.doc</strong>. Other formats, including PDFs, are not
//                       supported.
//                     </p>
//                     <p>
//                       2. Do not include blank spaces in the file name. Use underscores
//                       (_) or hyphens (-) instead.
//                     </p>
//                     <p>
//                       3. Question numbering format: Use hash (#) before the number and
//                       dot (.) after the number. Example - #1., #11., #111.
//                     </p>
//                     <p>4. Always keep one space after the dot (.) in question numbering.</p>
//                     <p>
//                       5. Option numbering format: Use (@) before the number and enclose
//                       it in brackets (). Example - (@1), (@2). Mark correct answers with
//                       an asterisk (*). Example - (@*1), (@*4).
//                     </p>
//                     <p>6. Do not use alphabets like (a, b, c, d) for options.</p>
//                     <p>
//                       7. Do not use subscript or superscript formatting (e.g., A
//                       <sub>2</sub> or A<sup>2</sup> is not allowed). Instead, use the
//                       insert equation feature. Example: A=πr^2.
//                     </p>
//                     <p>
//                       8. Adding images/pictures: .emf format is not supported. Use .png
//                       or .jpg formats.
//                     </p>
//                     <p>9. Always keep one blank line between questions and options.</p>
//                     <p>
//                       10. Word limit on Solution is{" "}
//                       <span style={{ fontWeight: "bold" }}>5000</span> characters.
//                     </p>
//                   </div>
//                 )}
//               </div>
//               <QuickDPPSchedulingTable
//                 parseQuesSetId={parseQuesSetId}
//                 clientId={clientId}
//                 clientBranchId={clientBranchId}
//                 setMessageBox={setMessageBox}
//                 setIsMessageBoxVisible={setIsMessageBoxVisible}
//                 setActiveImg={setActiveImg}
//                 dataClient={dataClient}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="create-ques-paper-ques-bank-preview-valiedate">
//         <button> Preview </button>
//       </div>
//     </div>
//   );
// };

// export default QuickDPPSchedulingDashboard;


